import 'babel-standalone';
import 'babel-polyfill';
import 'intersection-observer';

import Vue from 'vue';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import MeasureTextSizeService from '@/helper/MeasureTextSizeService';
import App from './App.vue';
import router from './router';
import store from './store';
import registry from './registry';

registry.register('measure', () => {
    const s = new MeasureTextSizeService();
    s.prepare();
    return s;
});

//後から追加したモジュール
import VueObserveVisibility from 'vue-observe-visibility';
Vue.use(VueObserveVisibility);
// var longpress = require('vue-long-press-directive')
// Vue.use(longpress, { duration: 5000 })
//後から追加したモジュール

Vue.config.productionTip = false;

const app = new Vue({
  "router" : router,
  "store" : store,
  render: function(createElement)
  {
    return createElement(App);
  }
}).$mount('#app');

// window.app に app の component を保持する
(window as any).app = app.$children && app.$children.length > 0 ? app.$children[0] : null;

// Electronではエラーになるので出さない
if (!UserAgentHelper.isElectron()) {
    // ページを閉じる前の確認ダイアログを出す
    window.addEventListener('beforeunload', (e) => {
        e.preventDefault();
        e.returnValue = '';
    }, false);
}

require("@/importControl/style/style.scss");
